export default __webpack_public_path__ + "static/media/dropdown-blue.0cc73496.svg";